import { ToolkitProperty, addressToString, orUndefined, syntaxFNMA } from '@aloft/toolkit-shared';

import { MatchProperty } from './types.ts';

const addrToString = orUndefined(addressToString);

export const toolkitPropertyToMatchProperty = (property: ToolkitProperty): MatchProperty => ({
  coords:
    property.latitude !== undefined && property.longitude !== undefined
      ? [property.longitude, property.latitude]
      : undefined,
  propertyType: property.propertyType,
  propertySubType: property.propertySubtype,
  marketingCommentary: property.marketingCommentary,
  address: addrToString(property.address),
  zipCode: property.address?.PostalCode,
  view: syntaxFNMA.viewSyntax.encode(property) || undefined,
  designStyle: property.designStyle || undefined,
  heatingCooling: property.heatingCooling,
  bedrooms: property.aboveGradeBedroomCount?.value,
  totalBathrooms: property.totalBathCount?.value,
  bathrooms: property.aboveGradeFullBathCount?.value,
  halfBathrooms: property.aboveGradeHalfBathCount?.value,
  threeQuarterBathrooms: property.aboveGradeThreeQuarterBathCount?.value,
  attachedGarageParkingSpacesCount: property.attachedGarageParkingSpacesCount?.value,
  stories: property.designNumberOfStories,
  glaSqFt: property.grossLivingArea?.toSqFt()?.unitAmount,
  basementSqFt: property.totalBasementArea?.toSqFt()?.unitAmount,
  siteSizeSqFt: property.site?.toSqFt()?.unitAmount,
  yearBuilt: property.yearBuilt,
  contractDate: property.contractDate?.toNumericDate(),
  saleDate: property.closeDate?.toNumericDate(),
  salePrice: property.salePrice?.toNumericPrice(),
  hasAttachment: property.hasAttachment,
  hasBasement: property.hasBasement,
});
